import styled from '@emotion/styled'

const StyledRadio = styled.input`
  width: 1.125rem;
  height: 1.125rem;
`

export default StyledRadio
